export default function getCdkSidFromOkta() {
  return (
    JSON.parse(localStorage.getItem('okta-token-storage') ?? '{}')?.accessToken
      ?.claims?.cdksid || ''
  );
}